import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import * as React from "react";
import { getContentTypes } from "../model/content-access";
import { getDataEntryContentTypes } from "../model/content-access";
import { NBSP } from "../utils/string";
import { DOCUMENT_TYPE_ICONS } from "./document-icons";
import { IAuthContextProps, withAuthContext } from "./with-auth-context";
import { SearchableContentType } from "../model/autogen/SearchableContentType";

export interface IContentTypePickerProps {
    name: string;
    label: string;
    contentType: SearchableContentType | "";
    onChange: (value: string) => void;
    dataEntry: boolean;
}

function getDisplayName(a: SearchableContentType): React.ReactNode {
    if (a == SearchableContentType.Quote) {
        return "Transcripts";
    }
    return a;
}


// tslint:disable-next-line:max-classes-per-file
export class ContentTypePickerComponent extends React.Component<IContentTypePickerProps & IAuthContextProps, any> {
    private onChange = (e: React.ChangeEvent<HTMLSelectElement>, child: React.ReactNode): void => {
        this.props.onChange(e.target.value);
    }
    // public render(): JSX.Element {
    //     return <SelectField label={this.props.label} name={this.props.name} fullWidth={true} value={this.props.contentType}
    //         onChange={this.onChange}>
    //         {TYPES.map(a => <MenuItem key={a} value={a}>{a}</MenuItem>)}
    //     </SelectField>;;
    // }

    public render() {
        const { label, name, contentType, user, dataEntry } = this.props;
        let enumValues = dataEntry === true ? getDataEntryContentTypes(parseInt(user.level as any, 10)) : getContentTypes(parseInt(user.level as any, 10));
        return <FormControl fullWidth={true}>
            <InputLabel htmlFor="content">{label}</InputLabel>
            <Select value={contentType ? contentType : ''} inputProps={{ name, id: "content" }} onChange={this.onChange}>
                <MenuItem value=""><em>Select item</em></MenuItem>
                {enumValues.map(a => <MenuItem key={a} value={a}>{DOCUMENT_TYPE_ICONS[a]}{NBSP}{getDisplayName(a)}</MenuItem>)}
            </Select>
        </FormControl>;
    }
}

export const ContentTypePicker = withAuthContext(ContentTypePickerComponent);


// WEBPACK FOOTER //
// ./src/components/content-type-picker.tsx